
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Този инструмент ви позволява да коригирате списъка със съставки. Можете да добавяте, премахвате или редактирате
                списък със съставки.
                <br>
                Този символ <span class="highlight">␣</span> представлява интервал.
                <br>
                Този символ <span class="highlight">↩︎</span> представлява нов ред. `,
'hb28f1f2ec1744ee9': html`Тези свойства се създават и подават от потребители за всякакъв вид употреба. Чувствайте се
                    свободни да добавяте свои собствени. Свойствата и стойностите, които създавате
                    <strong>, трябва да са фактически</strong>. Можете да се потопите в
                    <a href="${0}">списъка със свойства, които вече се използват от общността</a>
                    или да разгледате
                    <a href="${1}">документацията на свойствата и тяхната търсачка</a>.`,
's000a5b76bd3a01c2': `Зареждане на свойства...`,
's000d98595e959c1e': `Предлага се в Google Play`,
's013bdc8cf0d3583d': `Помогнете ни със съставките`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Валидиране на реколтата`,
's03e9c8114521b998': `Ще редактирам съставките`,
's05ec315d9308091a': `Икона за ъгли на баркод`,
's061eb5af92512c85': `Запазено! Можете ли да помогнете с още едно?`,
's06847c221c4c0bc1': `Бих искал да създам свойство за [опишете вашия случай на употреба]...`,
's06f6c6f99db6b552': `Оригинал`,
's081e2ad82db71e1d': `Групирани стойности`,
's09205907b5b56cda': `Не`,
's0b4235aae602a950': `специална документация`,
's0bb2d48532acc455': `Изтегляне на CSV файл`,
's0d5b7fee0311db68': `Имот`,
's0fb218abc2e157ed': `Невалидно изображение`,
's100c4928cc74642a': `да подпомагаме напредъка в научните изследвания в областта на общественото здраве.`,
's10db5498186c083b': `Отмяна на изрязването`,
's11a18a69b30b65ed': `Помогнете ни да поправим грешките в списъка със съставки`,
's1205d5f6fccf8e69': `Стойност на имота`,
's15d64a0a6715285a': `Нов ключ`,
's166bd56d19670a72': `Увеличение`,
's19059bf0c4f7c162': `Област за избор`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Помогнете ни да коригираме информацията за хранителната стойност`,
's1e00019dc454872d': `Моля, посочете име на свойство, като използвате атрибута property-name.`,
's1e49126af0935a5b': `Списък с продукти, използващи това свойство`,
's21e73088de6f26f3': `Изтегли от App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Отмени`,
's2db7b654c0a9bde0': `Документирайте имота`,
's300b3a6ee4e1252d': str`Слабо съвпадение ${0}%`,
's33f786bb6b4f0cf4': `Резултат от изрязване`,
's33f85f24c0f5f008': `Запис`,
's34be4af4e8fec4ae': `Първо попитайте общността`,
's36d86adc823cbfa6': `Преди да създадете нов имот, обсъдете го с общността:`,
's3781d25aa51a736c': `Документация на двигателя Folksonomy`,
's383ae4449428b61e': `Нулиране на изрязването`,
's39bcf88721a1e8ee': `Нулиране на избора`,
's39e14e14300694c7': `Документация и насоки`,
's3b430cfa5c1fe7f4': str`Документация за ${0}`,
's3f4e4b52f230a892': `Изображение на платното`,
's417b90913e05bc17': `Преглед`,
's41f7dca46d3f1b4a': `Стойност`,
's422bba9636ce2489': `Центриране на изображението`,
's42dd66b2441566fd': `Икона в центъра`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Добави хранително вещество`,
's453ab0dbb9b5c777': `Преоразмеряване надясно`,
's475b08749d0706ed': `Помогнете ни да информираме милиони потребители по света за това какво ядат`,
's49730f3d5751a433': `Зареждане...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Брой продукти`,
's4df2f533c0c1e7d0': `Контроли на изображенията`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Преместване на селекцията`,
's4f751fb9b3ed766c': `Създаване на нов имот`,
's547c12ae169d00bc': `Налично на F-Droid`,
's5560fb119e40923d': `Въведете име на имота...`,
's55d7249883a98ca1': `за този имот в уикито на Open Food Facts`,
's565867d84c04aea2': `Филтриране на свойства...`,
's5666afe5cd0166de': `Моля, поправете грешките или променете текста, преди да потвърдите`,
's57472465a23b41db': `Ценности`,
's58e1eeea7a60ae51': `Зареждане на продукти...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Помогнете ни да коригираме информацията за хранителната стойност.`,
's5dd6f12783fca34f': `Редактиране на списъка със съставки`,
's5e8250fb85d64c23': `Затвори`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `ПОДКРЕПЯМ`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Редактирай`,
's66413c24dcf680e2': `Пропусни`,
's67ae6594857a4d57': `Благодарим за приноса!`,
's6cee7cad81dfedd1': `Изрязано изображение`,
's6d7b6cdedaadfb6e': `Всяко дарение има значение! Оценяваме вашата подкрепа за осигуряване на допълнителна прозрачност на храните в света.`,
's7124dde792a8faa2': `APK за Android`,
's718dea04853f80ae': str`Добро съвпадение ${0}%`,
's71a5c9f4b68ef4d4': `Брой`,
's74cb3d66f6a668e1': `Документация`,
's787dd11bed0dc88a': `Преоразмеряване отляво`,
's7ce4fd9430e80cea': `стойност`,
's801a05fa8e881f37': `Научете повече за създаването на имоти и насоките:`,
's8038273de2cf8b73': `Моля, изберете регион за изрязване.`,
's839cc2908a5387f2': `Филтриране на баркодове...`,
's86197dcf3e96af64': `Разглеждайте и търсете съществуващи имоти`,
's8a63be30a129a59c': `Преоразмеряване на долната част`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Преоразмеряване горе вдясно`,
's8db84aa4bc949af2': `Документирайте новия имот`,
's8f839a03997a16d7': `Преглед на продукта`,
's901ae1e236ac45d3': `Отмяна на изтриването`,
's907f7a97c6b29425': `Имайте предвид, че моделът на данните може да бъде променен. Използвайте го на ваш собствен риск.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Съставки:`,
's9a7f60fce090ecaf': `Зареждането на свойствата не бе успешно. Моля, опитайте отново по-късно.`,
's9b87abd68fb9df45': `Не е намерен? Създайте нов ключ {value}`,
's9c0f52425fd2f07e': `Може да не съвпада`,
's9fc41f789c63b40d': `Продукти`,
'sa1fa766e0d5634d7': `Няма наличен резултат`,
'sa548778b24054030': `Разгледайте всички предоставени свойства от проекта Folksonomy Engine. Тези свойства предоставят допълнителни метаданни и информация за продуктите в базата данни Open Food Facts.`,
'sa63907958bd0ec4b': `Преоразмеряване горе вляво`,
'sa95b4224f685a36a': `Затвори модалния прозорец`,
'sab56a1d439576fd6': `Икона за предложение`,
'sac47ea2901d04c15': `Преоразмеряване долу вляво`,
'sb125227d436c2925': `Търсете вашата концепция за имот в съществуващата база данни с имоти:`,
'sb125568d43642e6f': `Отговорете на въпроси относно продукта.`,
'sb1c538e038f9b214': str`Много добро съвпадение ${0}%`,
'sb28639570ff3b852': `списък на всички имоти`,
'sb3bdd638a58d30f4': `да привлечем общност от заинтересовани граждани,`,
'sb3cbcc1bd0fff140': `След като сте потвърдили, че вашият имот не съществува и общността е съгласна, че е полезен, първо трябва да го документирате в уикито.`,
'sb3d4f79d9d8b71e5': `Потвърди`,
'sb560fa37a7bfb6c2': `Няма намерени продукти за този имот.`,
'sb7f72e4c8a2d3357': `Филтриране на стойности...`,
'sb8178320160f84ea': `Покажи изрязване`,
'sbad7d2734149470b': `Потвърди`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Всички въпроси са получили отговор! Благодаря за помощта!`,
'sbd9a0b2293b3cd3c': `Размер на порция`,
'sbe472dc3c2685985': `Съответстваща стойност`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Преоразмеряване на горната част`,
'sc1c08d0cbcc3bd24': `Не съвпада`,
'sc52696641af72b53': `Инсталирай приложението!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Предложено решение`,
'sc681b137e8f604f7': `Потвърждаване на изтриването`,
'sc6daf8a31883f8b9': `Преместване на изображение`,
'sc895972c88d38ca5': `Имот на фолксономията`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Редове`,
'scb3b0671d7b7f640': `Нова стойност`,
'scb489a1a173ac3f0': `Да`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Присъединете се към дискусията в Slack`,
'scdb6cad0b92721bf': `Не са намерени имоти.`,
'scf23a05631f93732': `Потвърждаване на изтриването`,
'scfed2f270ef6a3aa': `Изберете област`,
'sd1022bc1ef9204f7': `Мащабиращо се изображение`,
'sd1077c055cf9ba6b': `Помогнете ни да валидираме списъка със съставки на продукта.`,
'sd698d21ddecba56b': `Здравейте! Можете да ни помогнете да подобрим информацията за продукта, като отговорите на следните въпроси:`,
'sd82bc2decefa621b': `да оставанем независими от хранителната индустрия,`,
'sdb97e5976482606e': `Проверете дали вече съществува даден имот`,
'sdbf806fefc584115': `Трябва да намерите`,
'sdc673e73b5c13aea': `Изтрий`,
'sdc792b75f1edcaba': `Помогнете ни да коригираме правописа на съставките.`,
'sdca5deead576ceee': `Преоразмеряване долу вдясно`,
'sdcc2555c5dde524f': `Сигурни ли сте, че искате да изтриете този елемент? Това действие не може да бъде отменено.`,
'se206feec7ec57b28': `на 100 г`,
'se419a9ab36987490': `Анулирай`,
'se5127cf0f92e7e48': `Съвет: можете също да намерите`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Ще предложа по-добра реколта`,
'seea3800e27baa686': `Индивидуални продукти`,
'sefaba4adc4ec9219': `Фолксономи Пропъртис`,
'seffa8ca49175b5f0': `Персонализирани свойства`,
'sf44a6b3b232c28ea': str`Заменете текущата стойност с ${0}`,
'sf4cd86a2f5ef2588': `Баркод на продукта`,
'sf57a61152168cc81': `Помогнете ни да коригираме откриването на съставки`,
'sf88b90b8ba23871c': `Неизвестно съвпадение`,
'sf9aee319a006c9b4': `Добави`,
'sfacbbe968fa7d773': `Име на имота:`,
'sfc40ea3d5d5aa6f8': `Вашите дарения финансират ежедневните операции на нашата асоциация с нестопанска цел:`,
'sfe87465d50530725': `Съответстваща стойност`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  